module.exports = __webpack_public_path__ + "media/images/plans/img_proposal2-5e3558467570c58b7a05f6c4f788aa83.jpg";